<template>
  <div class="user-content">
    <div class="main-content">
      <user-info class="user-info" :editEnable="editEnable" :userId="routerUserId"></user-info>
      <div class="index-main shadow">
        <div class="list__header">
          <ul class="list__nav">
            <li class="list__nav-item" :class="{ 'list__nav-item--active': item.id === navId }" v-for="item in navs"
              :key="item.title" @click="changeNavType(item)">
              {{ item.title }}
            </li>
          </ul>
        </div>



        <!-- 谈谈内容 -->
        <div v-if="navId === 1">
          <div v-if="list.length > 0">
            <div v-for="(item, index) in list" :key="index" class="article-item">
              <h3 class="article-title">{{ item.title }}</h3>
              <p class="article-content">{{ item.content }}</p>
              <div class="article-meta">
                <span class="time">{{ item.createTime }}</span>
                <span class="views">阅读 {{ item.viewCount }}</span>
                <span class="likes">点赞 {{ item.likeCount }}</span>
              </div>
            </div>
          </div>
          <div v-else class="empty-tip">暂无内容</div>
        </div>

        <!-- 收藏夹内容 -->
        <div v-if="navId === 4">
          <div v-if="collectionList.length > 0">
            <div v-for="(item, index) in collectionList" :key="index" class="collection-item">
              <div class="collection-content">
                <h3 class="collection-title" @click="goToPaperDetail(item.paperId)">{{ item.title }}</h3>
                <p class="collection-desc">{{ item.description }}</p>
              </div>
              <div class="collection-meta">
                <span class="time">{{ item.createTime }}</span>
                <el-button v-if="editEnable" type="text" class="uncollect-btn" @click="uncollectPaper(item.paperId)"
                  :loading="item.loading">
                  <i class="el-icon-star-off"></i>
                  取消收藏
                </el-button>
              </div>
            </div>
            <!-- 加载更多按钮 -->
            <div v-if="pagination.collection.hasMore" class="load-more-wrapper">
              <el-button @click="loadMore" :loading="loadingMore" class="load-more-btn">
                {{ loadingMore ? '加载中...' : '加载更多' }}
              </el-button>
            </div>
          </div>
          <div v-else class="empty-tip">暂无收藏内容</div>
        </div>

        <!-- 随手记内容 -->
        <div v-if="navId === 5">
          <div v-if="noteList.length > 0">
            <div v-for="(item, index) in noteList" :key="index" class="note-item">
              <div class="note-header">
                <h3 class="note-title" @click="goToPaperDetail(item.paper.paperId)">
                  {{ item.paper.title }}
                  <span class="question-index">第{{ item.question.questionIndex }}题</span>
                </h3>
              </div>
              <div class="note-content" v-html="item.content || ''"></div>
              <div class="note-meta">
                <span class="time">{{ item.createTime }}</span>
                <el-button v-if="editEnable" type="text" class="delete-btn" @click="deleteNote(item.noteId)" :loading="item.loading">
                  <i class="el-icon-delete"></i>
                  删除
                </el-button>
              </div>
            </div>
            <!-- 加载更多按钮 -->
            <div v-if="pagination.note.hasMore" class="load-more-wrapper">
              <el-button @click="loadMore" :loading="loadingMore" class="load-more-btn">
                {{ loadingMore ? '加载中...' : '加载更多' }}
              </el-button>
            </div>
          </div>
          <div v-else class="empty-tip">暂无随手记</div>
        </div>

        <!-- 答案库内容 -->
        <div v-if="navId === 6">
          <div v-if="answerList.length > 0">
            <div v-for="(item, index) in answerList" :key="index" class="answer-item">
              <div class="answer-header">
                <h3 class="answer-title" @click="goToPaperDetail(item.paper.paperId)">
                  {{ item.paper.title }}
                  <span class="question-index">第{{ item.question.questionIndex }}题</span>
                </h3>
              </div>
              <div class="answer-content" v-html="item.content"></div>
              <div class="answer-meta">
                <span class="time">{{ item.createTime }}</span>
                <div class="action-buttons">
                  <div
                    class="ai-view-btn"
                    :class="{'ai-view-btn-disabled': item.aiAnalysisStatus === 'PROCESSING'}"
                    @click="analyzeAnswer(item)">
                    <img v-if="!item.aiLoading" class="btn-icon" src="@/assets/images/ai_icon.png" />
                    <i v-else class="el-icon-loading"></i>
                    <span>{{ getAiAnalysisButtonText(item.aiAnalysisStatus) }}</span>
                  </div>
                  <el-button v-if="editEnable" type="text" class="edit-btn" @click="openEditAnswerDialog(item)">
                    <i class="el-icon-edit"></i>
                    编辑
                  </el-button>
                  <el-button v-if="editEnable" type="text" class="delete-btn" @click="deleteUserAnswer(item.answerId)" :loading="item.loading">
                    <i class="el-icon-delete"></i>
                    删除
                  </el-button>
                </div>
              </div>
            </div>
            <!-- 加载更多按钮 -->
            <div v-if="pagination.answer.hasMore" class="load-more-wrapper">
              <el-button @click="loadMore" :loading="loadingMore" class="load-more-btn">
                {{ loadingMore ? '加载中...' : '加载更多' }}
              </el-button>
            </div>
          </div>
          <div v-else class="empty-tip">暂无答案记录</div>
        </div>

        <!-- 浏览记录内容 -->
        <div v-if="navId === 7">
          <div v-if="browseHistoryList.length > 0">
            <div v-for="section in browseHistoryList" :key="section.key" class="history-section">
              <div class="section-header">
                <span class="section-title">{{ section.tag }}</span>
              </div>
              <div v-for="record in section.records" :key="record.id" class="browse-history-item" @click="goToPaperDetail(record.paperId, record.questionIndex)">
                <div class="paper-title-wrapper">
                  <h3 class="paper-title">{{ record.paperTitle }}</h3>
                  <div class="title-actions">
                    <span class="question-order" v-if="record.questionOrder">{{ record.questionOrder }}</span>
                  </div>
                </div>
                <div class="question-preview">
                  <div class="question-content" v-html="record.content || '无内容预览'"></div>
                </div>
              </div>
            </div>
            <!-- 加载更多按钮 -->
            <div v-if="pagination.browseHistory.hasMore" class="load-more-wrapper">
              <el-button @click="loadMore" :loading="loadingMore" class="load-more-btn">
                {{ loadingMore ? '加载中...' : '加载更多' }}
              </el-button>
            </div>
          </div>
          <div v-else class="empty-tip">暂无浏览记录</div>
        </div>

      </div>
    </div>
    <!-- <div class="right-section">
      <about-author class="about-author" :info="articDetail"></about-author>
    </div> -->

    <!-- 编辑历史答案 -->
    <el-dialog
      title="编辑历史答案"
      :visible.sync="showEditAnswerDialog"
      width="760px"
      custom-class="answer-edit-dialog"
      :close-on-click-modal="false"
      @closed="resetEditAnswerDialog"
    >
      <div class="answer-edit-paper" v-if="editingAnswer">
        <span>{{ editingAnswer.paper && editingAnswer.paper.title }}</span>
        <em v-if="editingAnswer.question">第{{ editingAnswer.question.questionIndex }}题</em>
      </div>
      <quill-editor
        v-if="showEditAnswerDialog"
        v-model="editAnswerContent"
        :options="editAnswerEditorOption"
        @change="onEditAnswerChange"
      />
      <div class="answer-edit-count">{{ editAnswerContentLength }} 字</div>
      <span slot="footer" class="dialog-footer">
        <el-button class="answer-edit-cancel" @click="showEditAnswerDialog = false">取消</el-button>
        <el-button class="answer-edit-save" type="primary" :loading="savingEditAnswer" @click="saveEditUserAnswer">保存</el-button>
      </span>
    </el-dialog>

    <!-- AI助手对话框 -->
    <el-dialog
      title="AI助手"
      :visible.sync="showAiAssistantDialog"
      width="90%"
      top="5vh"
      custom-class="ai-assistant-dialog"
      :close-on-click-modal="false"
    >
      <AiAssistant v-if="showAiAssistantDialog" :answer-data="currentAnswerData" />
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import userInfo from "@/components/business/user/userInfo.vue";
import aboutAuthor from "@/components/business/detail/aboutAuthor.vue";
import AiAssistant from "@/components/business/aiAssistant/AiAssistant.vue";
import { getArticleList, getCollectPaperList, getUserAnswerList, getUserNoteList, doAction, deleteUserNote, deleteUserAnswer, getBrowseRecordList, aiAnalysisUserAnswer, getAiAnalysisFreeTrialRemaining, updateUserAnswer } from '@/api';
import { showPermissionDeniedTip } from '@/utils/permissionUtils';

export default {
  components: {
    userInfo,
    aboutAuthor,
    AiAssistant,
    quillEditor,
  },
  data() {
    return {
      editEnable: false,
      value: "",
      routerUserId: null,
      navs: [
        // {
        //   id: 1,
        //   title: "谈谈",
        //   type: 1,
        // },
        // {
        //   id: 2,
        //   title: "闲聊",
        //   type: 2,
        // },
        // {
        //   id: 3,
        //   title: "关注",
        //   type: 3,
        // },
        {
          id: 4,
          title: "收藏夹",
          type: 4,
        },
        {
          id: 5,
          title: "随手记合集",
          type: 5,
        },
        {
          id: 6,
          title: "我的答案库",
          type: 6,
        },
        {
          id: 7,
          title: "浏览记录",
          type: 7,
        },
      ],
      navId: 4,
      list: [],
      publishList: [],
      collectionList: [],
      noteList: [],
      answerList: [],
      browseHistoryList: [],
      loading: false,
      articDetail: {
        userInfo: this.$store.getters['user/getState']
      },
      versionVisable: false,
      showAiAssistantDialog: false, // 是否显示AI助手对话框
      currentAnswerData: null, // 当前选中的答案数据
      showEditAnswerDialog: false,
      editingAnswer: null,
      editAnswerContent: '',
      editAnswerContentLength: 0,
      savingEditAnswer: false,
      editAnswerEditorOption: {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'color': [] }],
            [{ 'align': [] }],
            ['clean']
          ]
        },
        placeholder: '请输入您的答案'
      },
      // 分页状态
      pagination: {
        collection: { pageNum: 1, pageSize: 10, total: 0, hasMore: true },
        note: { pageNum: 1, pageSize: 10, total: 0, hasMore: true },
        answer: { pageNum: 1, pageSize: 10, total: 0, hasMore: true },
        browseHistory: { pageNum: 1, pageSize: 10, total: 0, hasMore: true },
      },
      loadingMore: false, // 是否正在加载更多
    }
  },
  created() {
    this.routerUserId = this.$route.params.id;
    this.loadData();
  },
  watch: {
    '$route.params.id': {
      handler(newUserId) {
        if (newUserId !== this.routerUserId) {
          this.routerUserId = newUserId;
          this.loadData();
        }
      },
      immediate: false
    }
  },
  methods: {
    async loadData() {
      this.loading = true;
      const userId = this.$store.getters['user/getState'].userId;
      if(userId === Number.parseInt(this.routerUserId)) {
        this.editEnable = true;
      }
      // 重置所有分页状态
      this.resetPagination();
      try {
        await this.loadCurrentTabData();
      } catch (error) {
        console.error('加载数据失败:', error);
        this.$message.error('加载数据失败');
      } finally {
        this.loading = false;
      }
    },
    resetPagination() {
      this.pagination.collection = { pageNum: 1, pageSize: 10, total: 0, hasMore: true };
      this.pagination.note = { pageNum: 1, pageSize: 10, total: 0, hasMore: true };
      this.pagination.answer = { pageNum: 1, pageSize: 10, total: 0, hasMore: true };
      this.pagination.browseHistory = { pageNum: 1, pageSize: 10, total: 0, hasMore: true };
      this.collectionList = [];
      this.noteList = [];
      this.answerList = [];
      this.browseHistoryList = [];
    },
    async loadCurrentTabData() {
      switch (this.navId) {
        case 1: // 谈谈
          // await this.loadArticles();
          break;
        case 4: // 收藏夹
          await this.loadCollections();
          break;
        case 5: // 随手记合集
          await this.loadNotes();
          break;
        case 6: // 我的答案库
          await this.loadUserAnswers();
          break;
        case 7: // 浏览记录
          await this.loadBrowseHistory();
          break;
      }
    },
    async refreshUserAnswers() {
      this.pagination.answer = { pageNum: 1, pageSize: 10, total: 0, hasMore: true };
      this.answerList = [];
      await this.loadUserAnswers();
    },
    async loadArticles() {
      const params = {
        userId: this.routerUserId,
        pageSize: 10,
        pageNum: 1
      };
      const res = await getArticleList(params);
      this.list = res.rows || [];
    },
    async loadCollections() {
      const params = {
        userId: this.routerUserId,
        pageSize: this.pagination.collection.pageSize,
        pageNum: this.pagination.collection.pageNum
      };
      const res = await getCollectPaperList(params);
      const newData = res.rows || [];

      // 追加数据而不是替换
      this.collectionList = [...this.collectionList, ...newData];

      // 更新分页状态
      this.pagination.collection.total = res.total || 0;
      this.pagination.collection.hasMore = newData.length >= this.pagination.collection.pageSize;
    },
    async loadNotes() {
      const params = {
        userId: this.routerUserId,
        pageSize: this.pagination.note.pageSize,
        pageNum: this.pagination.note.pageNum,
        targetType: 2
      };
      const res = await getUserNoteList(params);
      const newData = res.rows || [];

      // 追加数据而不是替换
      this.noteList = [...this.noteList, ...newData];

      // 更新分页状态
      this.pagination.note.total = res.total || 0;
      this.pagination.note.hasMore = newData.length >= this.pagination.note.pageSize;
    },
    async loadUserAnswers() {
      const params = {
        userId: this.routerUserId,
        pageSize: this.pagination.answer.pageSize,
        pageNum: this.pagination.answer.pageNum
      };
      const res = await getUserAnswerList(params);
      const rows = res.rows || [];

      // 处理答案数据，添加 AI 评析相关字段
      const processedData = rows.map(item => {
        let radarScores = item.radarScores || null;
        if (typeof radarScores === 'string') {
          try {
            radarScores = JSON.parse(radarScores);
          } catch (error) {
            radarScores = null;
          }
        }

        return {
          ...item,
          answerComparison: item.answerComparison || '',
          coveragePercent: Number(item.coveragePercent || 0) || 0,
          estimatedScore: item.estimatedScore,
          estimatedScoreRate: item.estimatedScoreRate,
          questionScore: (item.question && item.question.score) || item.questionScore || null,
          radarScores: radarScores,
          structuredAdvice: item.structuredAdvice || '',
          personalizedRecommendation: item.personalizedRecommendation || '',
          missedScoringPoints: item.missedScoringPoints,
          aiAnalysisStatus: item.aiAnalysisStatus || null
        };
      });

      // 追加数据而不是替换
      this.answerList = [...this.answerList, ...processedData];

      // 更新分页状态
      this.pagination.answer.total = res.total || 0;
      this.pagination.answer.hasMore = rows.length >= this.pagination.answer.pageSize;
    },
    async changeNavType(item) {
      this.navId = item.id;
      // 切换标签时重置当前标签的分页状态
      switch (item.id) {
        case 4:
          this.pagination.collection = { pageNum: 1, pageSize: 10, total: 0, hasMore: true };
          this.collectionList = [];
          break;
        case 5:
          this.pagination.note = { pageNum: 1, pageSize: 10, total: 0, hasMore: true };
          this.noteList = [];
          break;
        case 6:
          this.pagination.answer = { pageNum: 1, pageSize: 10, total: 0, hasMore: true };
          this.answerList = [];
          break;
        case 7:
          this.pagination.browseHistory = { pageNum: 1, pageSize: 10, total: 0, hasMore: true };
          this.browseHistoryList = [];
          break;
      }
      await this.loadCurrentTabData();
    },
    async uncollectPaper(paperId) {
      try {
        // 找到对应的收藏项并设置loading状态
        const item = this.collectionList.find(item => item.paperId === paperId);
        if (item) {
          this.$set(item, 'loading', true);
        }

        // 调用取消收藏接口
        await doAction({
          status: '0',
          actionType: 3, // 收藏操作
          targetType: 1, // 试卷类型
          targetId: paperId
        });

        // 刷新收藏列表
        await this.loadCollections();
        this.$message.success('已取消收藏');
      } catch (error) {
        console.error('取消收藏失败:', error);
        this.$message.error('取消收藏失败，请重试');
      } finally {
        // 清除loading状态
        const item = this.collectionList.find(item => item.paperId === paperId);
        if (item) {
          this.$set(item, 'loading', false);
        }
      }
    },
    goToPaperDetail(paperId, questionIndex) {
      const normalizedPaperId = paperId == null ? '' : String(paperId).trim();
      if (normalizedPaperId && !['undefined', 'null'].includes(normalizedPaperId.toLowerCase())) {
        if (questionIndex) {
          this.$router.push(`/community/studyRoom/paper/detail/${encodeURIComponent(normalizedPaperId)}?questionIndex=${encodeURIComponent(questionIndex)}`);
        } else {
          this.$router.push(`/community/studyRoom/paper/detail/${encodeURIComponent(normalizedPaperId)}`);
        }
      } else {
        this.$message.warning('无效的试卷ID');
      }
    },

    async loadBrowseHistory() {
      try {
        const currentUserId = this.$store.getters['user/getState'].userId;

        if (!currentUserId) {
          this.browseHistoryList = [];
          return;
        }

        const params = {
          userId: currentUserId,
          pageSize: this.pagination.browseHistory.pageSize,
          pageNum: this.pagination.browseHistory.pageNum
        };
        const res = await getBrowseRecordList(params);

        const rows = Array.isArray(res?.rows) ? res.rows : [];

        // 按照移动端的方式标准化数据
        const normalizedList = rows.map(item => this.normalizeRecord(item));

        // 如果是第一页，直接分组；否则需要合并到现有分组中
        if (this.pagination.browseHistory.pageNum === 1) {
          // 按照时间分组
          this.browseHistoryList = this.groupHistory(normalizedList);
        } else {
          // 追加数据到现有分组
          this.appendToGroupedHistory(normalizedList);
        }

        // 更新分页状态
        this.pagination.browseHistory.total = res.total || 0;
        this.pagination.browseHistory.hasMore = rows.length >= this.pagination.browseHistory.pageSize;
      } catch (error) {
        console.error('加载浏览记录失败:', error);
        this.browseHistoryList = [];
      }
    },

    // 将新数据追加到已有的分组中
    appendToGroupedHistory(newRecords) {
      if (!Array.isArray(newRecords) || newRecords.length === 0) return;

      newRecords.forEach(item => {
        const groupMeta = this.resolveGroupMeta(item.browseTime || item.createTime);

        // 查找是否已有该分组
        let group = this.browseHistoryList.find(g => g.key === groupMeta.key);

        if (group) {
          // 如果分组存在，追加记录
          group.records.push(item);
          // 重新排序该分组内的记录
          group.records.sort((a, b) => (b.browseTime || 0) - (a.browseTime || 0));
        } else {
          // 如果分组不存在，创建新分组
          this.browseHistoryList.push({
            key: groupMeta.key,
            tag: groupMeta.tag,
            formattedDate: groupMeta.formattedDate,
            timestamp: groupMeta.timestamp,
            records: [item]
          });
          // 重新排序所有分组
          this.browseHistoryList.sort((a, b) => b.timestamp - a.timestamp);
        }
      });
    },

    // 按照时间分组，参考移动端逻辑
    groupHistory(list) {
      if (!Array.isArray(list) || list.length === 0) return [];

      const groups = {};
      list.forEach(item => {
        const groupMeta = this.resolveGroupMeta(item.browseTime || item.createTime);
        if (!groups[groupMeta.key]) {
          groups[groupMeta.key] = {
            key: groupMeta.key,
            tag: groupMeta.tag,
            formattedDate: groupMeta.formattedDate,
            timestamp: groupMeta.timestamp,
            records: []
          };
        }
        groups[groupMeta.key].records.push(item);
      });

      return Object.values(groups)
        .sort((a, b) => b.timestamp - a.timestamp)
        .map(group => {
          group.records = group.records.sort((a, b) => (b.browseTime || 0) - (a.browseTime || 0));
          return group;
        });
    },

    // 解析分组元数据，参考移动端逻辑
    resolveGroupMeta(time) {
      const now = this.stripTime(new Date());
      const recordDate = this.stripTime(time);
      const diff = Math.floor((now.getTime() - recordDate.getTime()) / (24 * 3600 * 1000));

      if (diff === 0) {
        return {
          key: 'today',
          tag: '今天',
          formattedDate: this.formatDate(recordDate),
          timestamp: recordDate.getTime()
        };
      }
      if (diff === 1) {
        return {
          key: 'yesterday',
          tag: '昨天',
          formattedDate: this.formatDate(recordDate),
          timestamp: recordDate.getTime()
        };
      }
      const key = this.formatDate(recordDate, '-');
      return {
        key: key,
        tag: this.formatDate(recordDate),
        formattedDate: this.formatDate(recordDate),
        timestamp: recordDate.getTime()
      };
    },

    formatDate(date, separator = '') {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');

      if (separator) {
        return `${year}${separator}${month}${separator}${day}`;
      }
      return `${year}年${month}月${day}日`;
    },

    // 按照移动端的方式标准化记录数据
    normalizeRecord(item) {
      const questionIndex = item.questionIndex || item.questionNo;

      // 处理试卷标题
      let paperTitle = '试卷';
      if (item.paper && item.paper.title) {
        paperTitle = item.paper.title;
      } else if (item.paperTitle || item.title || item.paperName) {
        paperTitle = item.paperTitle || item.title || item.paperName;
      }

      // 处理题目内容，保留HTML格式
      let content = '';
      if (item.question && item.question.content) {
        content = item.question.content;
      } else if (item.content || item.questionContent || item.questionBody) {
        content = item.content || item.questionContent || item.questionBody;
      }

      return {
        id: item.recordId || item.id || `${item.paperId || 'paper'}-${questionIndex || '0'}-${item.browseTime || Math.random()}`,
        paperId: item.paperId || item.paperID || '',
        questionIndex,
        paperTitle,
        questionOrder: item.questionOrder || (questionIndex ? `第${questionIndex}题` : ''),
        content,
        browseTime: item.browseTime ? new Date(item.browseTime).getTime() : (item.createTime ? new Date(item.createTime).getTime() : Date.now()),
        createTime: item.createTime || item.browseTime
      };
    },

    formatViewTime(timestamp) {
      if (!timestamp) return '';

      const now = new Date();
      const time = new Date(timestamp);

      // 检查时间是否有效
      if (isNaN(time.getTime())) {
        return timestamp; // 如果无法解析，直接返回原字符串
      }

      const nowDate = this.stripTime(now);
      const recordDate = this.stripTime(time);
      const diff = Math.floor((nowDate.getTime() - recordDate.getTime()) / (24 * 3600 * 1000));

      if (diff === 0) {
        return '今天';
      }
      if (diff === 1) {
        return '昨天';
      }
      if (diff < 7) {
        return `${diff}天前`;
      }

      // 超过一周显示具体日期
      return time.toLocaleDateString();
    },

    stripTime(date) {
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return d;
    },

    
    async deleteNote(noteId) {
      try {
        // 找到对应的笔记项并设置loading状态
        const item = this.noteList.find(item => item.noteId === noteId);
        if (item) {
          this.$set(item, 'loading', true);
        }

        await this.$confirm('确定要删除这条笔记吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 调用删除笔记接口
        await deleteUserNote(noteId);

        // 刷新笔记列表
        await this.loadNotes();
        this.$message.success('笔记已删除');
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除笔记失败:', error);
          this.$message.error('删除笔记失败，请重试');
        }
      } finally {
        // 清除loading状态
        const item = this.noteList.find(item => item.noteId === noteId);
        if (item) {
          this.$set(item, 'loading', false);
        }
      }
    },

    async deleteUserAnswer(answerId) {
      try {
        // 找到对应的答案项并设置loading状态
        const item = this.answerList.find(item => item.answerId === answerId);
        if (item) {
          this.$set(item, 'loading', true);
        }

        await this.$confirm('确定要删除这条答案吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 调用删除答案接口
        await deleteUserAnswer(answerId);

        // 刷新答案列表
        await this.refreshUserAnswers();
        this.$message.success('答案已删除');
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除答案失败:', error);
          this.$message.error('删除答案失败，请重试');
        }
      } finally {
        // 清除loading状态
        const item = this.answerList.find(item => item.answerId === answerId);
        if (item) {
          this.$set(item, 'loading', false);
        }
      }
    },

    openEditAnswerDialog(answerItem) {
      this.editingAnswer = { ...answerItem };
      this.editAnswerContent = answerItem.content || '';
      this.editAnswerContentLength = this.getPlainTextFromHtml(this.editAnswerContent).length;
      this.showEditAnswerDialog = true;
    },

    resetEditAnswerDialog() {
      this.editingAnswer = null;
      this.editAnswerContent = '';
      this.editAnswerContentLength = 0;
      this.savingEditAnswer = false;
    },

    onEditAnswerChange({ html, text }) {
      this.editAnswerContent = html || '';
      this.editAnswerContentLength = this.normalizeEditorText(text).length;
    },

    normalizeEditorText(text) {
      return (text || '').replace(/[\n\r\s\u00a0]/g, '');
    },

    getPlainTextFromHtml(html) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html || '';
      return (tempDiv.textContent || tempDiv.innerText || '').replace(/\u00a0/g, ' ').trim();
    },

    async saveEditUserAnswer() {
      if (!this.editingAnswer || this.savingEditAnswer) return;

      if (!this.getPlainTextFromHtml(this.editAnswerContent)) {
        this.$message.warning('答案内容不能为空');
        return;
      }

      this.savingEditAnswer = true;
      try {
        const data = {
          answerId: this.editingAnswer.answerId,
          dataType: this.editingAnswer.dataType,
          content: this.editAnswerContent,
          aiAnalysisStatus: 'NOT_STARTED',
          answerComparison: '',
          coveragePercent: 0,
          estimatedScore: 0,
          estimatedScoreRate: 0,
          radarScores: '{}',
          structuredAdvice: '',
          personalizedRecommendation: '',
          missedScoringPoints: '',
          aiAnalysisError: ''
        };

        await updateUserAnswer(data);
        await this.refreshUserAnswers();
        this.showEditAnswerDialog = false;
        this.$message.success('答案已保存');
      } catch (error) {
        console.error('保存答案失败:', error);
        this.$message.error('保存答案失败，请重试');
      } finally {
        this.savingEditAnswer = false;
      }
    },

    async analyzeAnswer(answerItem) {
      const userInputAnswer = (answerItem && answerItem.content) || '';
      const cleanedAnswer = userInputAnswer.replace(/<[^>]*>/g, '').trim();
      if (!cleanedAnswer) {
        this.$message.warning('答案内容为空，无法分析');
        return;
      }

      // 判断是否需要调用AI评析接口
      const aiAnalysisStatus = answerItem.aiAnalysisStatus;

      // 如果正在评析中，不允许点击
      if (aiAnalysisStatus === 'PROCESSING') {
        this.$message.info('AI正在评析中，请稍后查看');
        return;
      }

      if (!aiAnalysisStatus || aiAnalysisStatus === 'NOT_STARTED' || aiAnalysisStatus === 'FAILED' || aiAnalysisStatus === 'UNKNOWN') {
        // 尚未评析，先检查剩余次数，再调用AI评析接口
        try {
          this.$set(answerItem, 'aiLoading', true);
          try {
            await getAiAnalysisFreeTrialRemaining();
          } catch (e) {
            this.$message.error('权限检查失败，请重试');
            return;
          }

          const requestData = {
            answerId: answerItem.answerId
          };

          const res = await aiAnalysisUserAnswer(requestData);
          let message = res.msg || 'AI评析已启动，请稍等2～3分钟查询结果';

          try {
            const updatedRes = await getAiAnalysisFreeTrialRemaining();
            const updatedPayload = (updatedRes && updatedRes.data) ? updatedRes.data : updatedRes;
            const updatedRemaining = Number(updatedPayload && updatedPayload.remaining);
            const updatedIsVip = Boolean(updatedPayload && updatedPayload.isVip);
            if (!updatedIsVip && Number.isFinite(updatedRemaining) && updatedRemaining >= 0) {
              message += `（剩余免费次数：${updatedRemaining}次）`;
            }
          } catch (e) {
            // 获取剩余次数失败时，不影响主流程
          }

          this.$message.success(message);

          // 直接更新本地状态为 PROCESSING
          const index = this.answerList.findIndex(item => item.answerId === answerItem.answerId);
          if (index !== -1) {
            this.$set(this.answerList[index], 'aiAnalysisStatus', 'PROCESSING');
          }
        } catch (error) {
          console.error('AI评析请求失败:', error);
          const errorMsg = typeof error === 'string' ? error : (error && error.msg) || '';
          if (errorMsg.includes('免费试用次数已用完') || errorMsg.includes('开通尊享版会员')) {
            showPermissionDeniedTip(['ai_analysis'], this);
          } else {
            this.$message.error(errorMsg || 'AI评析请求失败，请重试');
          }
        } finally {
          this.$set(answerItem, 'aiLoading', false);
        }
        return;
      }

      // 已有评析结果，显示AI助手对话框
      const resolvedQuestionScore = Number(
        (answerItem.question && answerItem.question.score) || answerItem.questionScore || 10
      );
      this.currentAnswerData = {
        ...answerItem,
        score: resolvedQuestionScore > 0 ? resolvedQuestionScore : 10,
        questionId: answerItem.question && answerItem.question.questionId ? answerItem.question.questionId : null,
        userAnswer: answerItem.content,
        userInputAnswer: answerItem.content
      };
      this.showAiAssistantDialog = true;
    },

    getAiAnalysisButtonText(aiAnalysisStatus) {
      // null / NOT_STARTED 显示"开始AI评析"
      // FAILED / UNKNOWN 显示"重新AI评析"
      // PROCESSING 显示"评析中"
      // COMPLETED 显示"查看AI评析"
      if (!aiAnalysisStatus || aiAnalysisStatus === 'NOT_STARTED') {
        return '开始AI评析';
      }
      if (aiAnalysisStatus === 'FAILED' || aiAnalysisStatus === 'UNKNOWN') {
        return '重新AI评析';
      }
      if (aiAnalysisStatus === 'PROCESSING') {
        return '评析中';
      }
      return '查看AI评析';
    },

    // 加载更多数据
    async loadMore() {
      if (this.loadingMore) return;

      this.loadingMore = true;
      try {
        switch (this.navId) {
          case 4: // 收藏夹
            if (!this.pagination.collection.hasMore) {
              this.$message.info('没有更多数据了');
              return;
            }
            this.pagination.collection.pageNum++;
            await this.loadCollections();
            break;
          case 5: // 随手记合集
            if (!this.pagination.note.hasMore) {
              this.$message.info('没有更多数据了');
              return;
            }
            this.pagination.note.pageNum++;
            await this.loadNotes();
            break;
          case 6: // 我的答案库
            if (!this.pagination.answer.hasMore) {
              this.$message.info('没有更多数据了');
              return;
            }
            this.pagination.answer.pageNum++;
            await this.loadUserAnswers();
            break;
          case 7: // 浏览记录
            if (!this.pagination.browseHistory.hasMore) {
              this.$message.info('没有更多数据了');
              return;
            }
            this.pagination.browseHistory.pageNum++;
            await this.loadBrowseHistory();
            break;
        }
      } catch (error) {
        console.error('加载更多失败:', error);
        this.$message.error('加载更多失败，请重试');
      } finally {
        this.loadingMore = false;
      }
    }
  },
};
</script>
<style lang="scss" scoped>
/* AI助手对话框样式 */
::v-deep .ai-assistant-dialog {
  .el-dialog__header {
    background: #fff;
    padding: 20px 20px 10px;

    .el-dialog__title {
      font-size: 18px;
      color: #303133;
      font-weight: 500;
    }
  }

  .el-dialog__body {
    padding: 0;
    max-height: 80vh;
    overflow-y: auto;
  }
}

.user-content {
  display: flex;
  gap: 20px;
  padding: 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  .main-content {
    flex: 1;
    min-width: 0;
    width: 100%;
  }

  .right-section {
    width: 300px;
    flex-shrink: 0;
  }
}

.index-main {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
}

.list__header {
  margin-bottom: 20px;
  border-bottom: 1px solid #e4e6eb;
}

.list__nav {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;

  .list__nav-item {
    padding: 12px 24px;
    cursor: pointer;
    position: relative;
    color: #86909c;

    &:hover {
      color: #1d2129;
    }

    &--active {
      color: #1d2129;
      font-weight: 500;

      &:after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        right: 0;
        height: 2px;
        background: #46B4B1;
      }
    }
  }
}

.empty-tip {
  text-align: center;
  color: #86909c;
  padding: 40px 0;
}

.article-item,
.collection-item,
.note-item,
.answer-item {
  padding: 20px 0;
  border-bottom: 1px solid #e4e6eb;

  &:last-child {
    border-bottom: none;
  }

  .article-title,
  .collection-title {
    font-size: 16px;
    font-weight: 500;
    color: #1d2129;
    margin: 0 0 12px;
  }

  .article-content,
  .collection-desc,
  .note-content,
  .answer-content {
    font-size: 14px;
    color: #4e5969;
    margin: 0 0 12px;
    line-height: 1.6;
  }

  .article-meta,
  .collection-meta,
  .note-meta,
  .answer-meta {
    font-size: 12px;
    color: #86909c;

    span {
      margin-right: 16px;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.collection-item {
  padding: 20px 0;
  border-bottom: 1px solid #e4e6eb;
  display: flex;
  flex-direction: column;

  &:last-child {
    border-bottom: none;
  }

  .collection-content {
    flex: 1;
  }

  .collection-title {
    font-size: 16px;
    font-weight: 500;
    color: #1d2129;
    margin: 0 0 12px;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: #46B4B1;
    }
  }

  .collection-desc {
    font-size: 14px;
    color: #4e5969;
    margin: 0 0 12px;
    line-height: 1.6;
  }

  .collection-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #86909c;

    .uncollect-btn {
      padding: 0;
      font-size: 12px;
      color: #f56c6c;

      &:hover {
        color: #f78989;
      }

      i {
        margin-right: 4px;
      }
    }
  }
}

.answer-item {
    padding: 20px 0;
    border-bottom: 1px solid #e4e6eb;

    &:last-child {
      border-bottom: none;
    }

    .answer-header {
      margin-bottom: 12px;
    }

    .answer-title {
      font-size: 16px;
      font-weight: 500;
      color: #1d2129;
      cursor: pointer;
      transition: color 0.3s;
      display: flex;
      align-items: center;

      &:hover {
        color: #46B4B1;
      }

      .question-index {
        margin-left: 8px;
        font-size: 14px;
        color: #86909c;
        font-weight: normal;
      }
    }
    .answer-content {
      font-size: 14px;
      color: #4e5969;
      margin: 12px 0;
      line-height: 1.6;
      background-color: #f9f9f9;
      padding: 12px;
      border-radius: 4px;
    }

    .answer-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #86909c;

    .action-buttons {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .ai-view-btn {
      display: inline-flex;
      align-items: center;
      padding: 6px 14px;
      font-size: 12px;
      border-radius: 14px;
      border: 1px solid rgba(120, 120, 255, 0.35);
      background: rgba(120, 120, 255, 0.1);
      color: #6655c4;
      cursor: pointer;
      transition: all 0.3s;
      gap: 6px;

      &:hover {
        background: rgba(120, 120, 255, 0.15);
        border-color: rgba(120, 120, 255, 0.5);
      }

      .btn-icon {
        width: 18px;
        height: 18px;
        border-radius: 4px;
      }

      i {
        font-size: 14px;
      }

      &.ai-view-btn-disabled {
        opacity: 0.5;
        border: 1px solid rgba(120, 120, 120, 0.35);
        background: rgba(120, 120, 120, 0.1);
        color: #999;
        cursor: not-allowed;

        &:hover {
          background: rgba(120, 120, 120, 0.1);
          border-color: rgba(120, 120, 120, 0.35);
        }
      }
    }

    .delete-btn {
      padding: 0;
      font-size: 12px;
      color: #f56c6c;

      &:hover {
        color: #f78989;
      }

      i {
        margin-right: 4px;
      }
    }

    .edit-btn {
      padding: 0;
      font-size: 12px;
      color: #46B4B1;

      &:hover {
        color: #378F8C;
      }

      i {
        margin-right: 4px;
      }
    }
  }
  }

::v-deep .answer-edit-dialog {
  .el-dialog__body {
    padding: 14px 20px 8px;
    position: relative;
    z-index: 1;
  }

  .el-dialog__footer {
    position: relative;
    z-index: 2;
  }

  .quill-editor {
    position: relative;
    z-index: 1;

    .ql-container {
      height: 260px;
      min-height: 260px;
    }

    .ql-editor {
      max-height: 260px;
      overflow-y: auto;
    }
  }
}

.answer-edit-paper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  color: #1d2129;
  font-size: 14px;
  line-height: 1.5;

  span {
    font-weight: 500;
  }

  em {
    flex-shrink: 0;
    font-style: normal;
    color: #46B4B1;
    font-size: 12px;
  }
}

.answer-edit-count {
  margin-top: 6px;
  text-align: right;
  color: #86909c;
  font-size: 12px;
  position: relative;
  z-index: 1;
}

::v-deep .answer-edit-cancel {
  color: #606266;
  background: #fff;
  border-color: #dcdfe6;

  &:hover,
  &:focus {
    color: #46B4B1;
    background: rgba(70, 180, 177, 0.06);
    border-color: rgba(70, 180, 177, 0.45);
  }
}

::v-deep .answer-edit-save {
  color: #fff;
  background: #46B4B1;
  border-color: #46B4B1;

  &:hover,
  &:focus {
    background: #378F8C;
    border-color: #378F8C;
  }
}

.note-item {
  padding: 20px 0;
  border-bottom: 1px solid #e4e6eb;

  &:last-child {
    border-bottom: none;
  }

  .note-header {
    margin-bottom: 12px;
  }

  .note-title {
    font-size: 16px;
    font-weight: 500;
    color: #1d2129;
    cursor: pointer;
    transition: color 0.3s;
    display: flex;
    align-items: center;

    &:hover {
      color: #46B4B1;
    }

    .question-index {
      margin-left: 8px;
      font-size: 14px;
      color: #86909c;
      font-weight: normal;
    }
  }


  .note-content {
    font-size: 14px;
    color: #4e5969;
    margin: 12px 0;
    line-height: 1.6;
    background-color: #f9f9f9;
    padding: 12px;
    border-radius: 4px;

    :deep(img) {
      max-width: 100%;
      height: auto;
      border-radius: 6px;
      margin: 6px 0;
      display: block;
    }
  }

  .note-meta {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #86909c;

    .delete-btn {
      padding: 0;
      font-size: 12px;
      color: #f56c6c;

      &:hover {
        color: #f78989;
      }

      i {
        margin-right: 4px;
      }
    }
  }
}

.history-section {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }

  .section-header {
    display: flex;
    align-items: baseline;
    margin-bottom: 16px;
    padding: 0 4px;

    .section-title {
      font-size: 18px;
      font-weight: 600;
      color: #1d2129;
    }
  }
}

.browse-history-item {
  padding: 12px 0;
  border-bottom: 1px solid #e4e6eb;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }

  .paper-title-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;

    .paper-title {
      font-size: 16px;
      font-weight: 500;
      color: #1d2129;
      margin: 0;
      flex: 1;
      line-height: 1.4;
      cursor: pointer;
      transition: color 0.3s;
      display: flex;
      align-items: center;

      &:hover {
        color: #46B4B1;
      }
    }

    .title-actions {
      display: flex;
      align-items: center;
      gap: 8px;

      .question-order {
        flex-shrink: 0;
        font-size: 12px;
        color: #46B4B1;
        font-weight: 600;
        background: rgba(70, 180, 177, 0.15);
        padding: 4px 10px;
        border-radius: 12px;
        border: 1px solid rgba(70, 180, 177, 0.2);
      }
    }
  }

  .question-preview {
    margin-bottom: 12px;

    .question-content {
      font-size: 14px;
      color: #4e5969;
      line-height: 1.6;
      background-color: #f9f9f9;
      padding: 12px;
      border-radius: 4px;
      min-height: 40px; // 最小高度，确保有基本内容显示
    }
  }

  }

// 加载更多按钮样式
.load-more-wrapper {
  text-align: center;
  padding: 24px 0;
  margin-top: 16px;
  border-top: 1px solid #e4e6eb;

  .load-more-btn {
    min-width: 120px;
    padding: 10px 24px;
    font-size: 14px;
    color: #46B4B1;
    border-color: #46B4B1;
    border-radius: 4px;
    transition: all 0.3s;

    &:hover {
      background-color: #46B4B1;
      color: #fff;
    }

    &:active {
      background-color: #3a9592;
    }
  }
}
</style>
